export default __webpack_public_path__ + "static/servicemap-1-7e114a9f59878ee04f33918771df7478.png";